import { City } from "../Models";
import { APIURL } from "./config";

export const generateUniversityRankings = async (
  rankTypeId: string,
  generateRank: { ids?: string[] },
  token: string
) => {
  const res = await fetch(
    `${APIURL}/AI/GenerateRanks/University/${rankTypeId}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(generateRank),
    }
  );

  const json = await res.json();
  return json;
};

export const generateCompanyRankings = async (
  rankTypeId: string,
  generateRank: { ids?: string[] },
  token: string
) => {
  const res = await fetch(`${APIURL}/AI/GenerateRanks/Company/${rankTypeId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(generateRank),
  });

  const json = await res.json();
  return json;
};

export const getCityDetailsUsingGPT = async (city: City, token: string) => {
  const response = await fetch(`${APIURL}/AI/GetCityDetails`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(city),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to get city details");
  }

  return await response.json();
};

export const getUniversityURLsUsingGPT = async () => {
  const response = await fetch(`${APIURL}/AI/GetUniversityURL`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },

  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to get university URLs");
  }

  return await response.json();
};

export const ExtractCVDataForRole = async (roleId: string, token: string) => {
  await fetch(`${APIURL}/AI/ValidateCVDetails/${roleId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(() => {
    return;
  })
}

export const ValidateCvCandidate = async (candidateId: string, token: string) => {
  await fetch(`${APIURL}/AI/ValidateCVDetailsByCandidate/${candidateId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then(() => {
    return;
  })
}